let permissionsCache = null;
export const setPermissions = (permissions) => {
    permissionsCache = permissions;
};
export const getPermissions = () => {
    return permissionsCache || [];
};
export const getPermissionByPageId = (pageId) => {
    if (!permissionsCache) {
        return undefined;
    }
    return permissionsCache.find(p => p.pageId === pageId);
};
export const hasPermission = (pageId) => {
    const permission = getPermissionByPageId(pageId);
    return permission !== undefined && permission.permissionType !== '0000';
};
export const isPermissionsLoaded = () => {
    return permissionsCache !== null;
};
let operationPermissionsCache = null;
export const setOperationPermissions = (permissions) => {
    operationPermissionsCache = permissions;
};
export const getOperationPermission = (pageId) => {
    if (!operationPermissionsCache) {
        return undefined;
    }
    return operationPermissionsCache.find(p => p.pageId === pageId);
};
export const isOperationPermissionsLoaded = () => {
    return operationPermissionsCache !== null;
};
